import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useForm } from "react-hook-form";

import { useFirebase } from 'react-redux-firebase'

const ForgotPassword = () => {
  const {register, handleSubmit} = useForm();
  const [result, setResult] = useState("");
  const firebase = useFirebase();

  const reset = async ({email}) => {
    const resetPassword = firebase.functions().httpsCallable('resetPassword');

    setResult("");

    try {
      await resetPassword({email});
      setResult("Reset instructions sent")
    } catch (e) {
      setResult("No account found for that email")
    }
}

  return (
    <div className="container">
      <a href="https://narratedbypoise.com" className="logo">Poise</a>
      <a href="https://narratedbypoise.com" className="back back-home">
        <i className="fas fa-long-arrow-alt-left"></i>
        &nbsp;
        Back home
      </a>
      <div className="row  justify-content-center text-center mt-5">
        <div className="col-md-12 col-lg-5 col-xl-5 mt-5">
          <div className="card screen reset">
             <div className="credentials">
               <h1 className="h3">Reset password</h1>
               <p>
                 Enter your email &amp; we'll email instructions to reset your password.
               </p>
               <form className="text-left" onSubmit={handleSubmit(reset)}>
                 <div className="form-group mb-4">
                   <label>Email*</label>
                   <input type="text" name="email" className="form-control" ref={register}/>
                 </div>
                { result && (
                   <p className="alert alert-warning text-center">
                     {result}
                   </p>
                 )}
                 <div className="form-group pb-3">
                   <input type="submit" className="btn btn-primary btn-block" value="Continue" />
                 </div>
               </form>
               <p className="text-center mb-0">
                 <Link to="/login">Back to log in</Link>
               </p>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
